import { AppRouteApi } from "../../config/appRoute";
import { ApiResponseContainer } from "../../models/api";
import { ApiSchemaDataExchangeSetting } from "../../models/api/dataExchangeSetting";
import { UtilityError } from "../../utils";
import { AxiosAuth } from "../axios";

async function GetByCompanyId(
  companyId: string
): Promise<ApiResponseContainer<ApiSchemaDataExchangeSetting>> {
  try {
    const response = await AxiosAuth.get<ApiResponseContainer<ApiSchemaDataExchangeSetting>>(
      `${AppRouteApi.DataExchangeSetting.v1()}/Company/${companyId}`
    );
    return response.data;
  } catch (error: any) {
    console.error(error);
    const errorMessage = error?.message || "Failed to fetch HHA configuration";
    UtilityError.parseErrorMessage(error);
    throw new Error(errorMessage);
  }
}

async function Update(
  companyId: string,
  data: Partial<ApiSchemaDataExchangeSetting>
): Promise<ApiResponseContainer<ApiSchemaDataExchangeSetting>> {
  try {
    const response = await AxiosAuth.put<ApiResponseContainer<ApiSchemaDataExchangeSetting>>(
      `${AppRouteApi.DataExchangeSetting.v1()}/Company/${companyId}`,
      data
    );
    return response.data;
  } catch (error: any) {
    console.error(error);
    const errorMessage = error?.message || "Failed to update HHA configuration";
    UtilityError.parseErrorMessage(error);
    throw new Error(errorMessage);
  }
}

async function Create(
  data: Omit<ApiSchemaDataExchangeSetting, 'sKey' | 'companyName'>
): Promise<ApiResponseContainer<ApiSchemaDataExchangeSetting>> {
  try {
    const response = await AxiosAuth.post<ApiResponseContainer<ApiSchemaDataExchangeSetting>>(
      `${AppRouteApi.DataExchangeSetting.v1()}/Company`,
      data
    );
    return response.data;
  } catch (error: any) {
    console.error(error);
    const errorMessage = error?.message || "Failed to create HHA configuration";
    UtilityError.parseErrorMessage(error);
    throw new Error(errorMessage);
  }
}

export const ApiDataExchangeConfig = {
  GetByCompanyId,
  Update,
  Create,
};